import React from 'react'
import { toPath } from '../../routes'
import { PageHeader } from '../Common'
import PracticeSelectView from '../Practices/PracticeSelectView'

export default function Cycles() {
  return (
    <div>
      <PageHeader title="Remote Schedule" />
      <PracticeSelectView routeMethod={toPath.practices.cycles} />
    </div>
  )
}
